import { render, staticRenderFns } from "./HomeItemTitle.vue?vue&type=template&id=9b680d78"
import script from "./HomeItemTitle.vue?vue&type=script&lang=js"
export * from "./HomeItemTitle.vue?vue&type=script&lang=js"
import style0 from "./HomeItemTitle.vue?vue&type=style&index=0&id=9b680d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports